import React from 'react';
import {Alert} from '@mui/material';

export default function InfoNotification({message}) {
    return (
        <Alert severity="info" sx={{mb: 2}}>
            {message}
        </Alert>
    );
}
